const KEYS = {
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
  ENTER: 'Enter',
  SPACE: ' ',
  TAB: 'Tab',
};
export default KEYS;
